import { defineMessages } from 'react-intl';

export default defineMessages({
    accountTitle: {
        id: 'gateway.views.landing.Account:',
        defaultMessage: 'Account: ',
    },
    policyNavigation: {
        id: 'gateway.navigation.landing.Policy:',
        defaultMessage: 'Policy: ',
    },
    quote: {
        id: 'gateway.views.quote-detail.Quote',
        defaultMessage: 'Quote',
    },
    policyChange: {
        id: 'gateway.views.endorsement-detail.Policy Change',
        defaultMessage: 'Policy Change',
    },
    renewal: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.Renewal',
        defaultMessage: 'Renewal',
    },
});
